var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram",
    clipPath: "url(#clip0_231_22020)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624374",
    x: 0.462891,
    width: 62.0001,
    height: 62,
    rx: 24.8,
    fill: "url(#paint0_linear_231_22020)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.0658 16.1682C48.3016 15.686 49.5792 16.7674 49.3078 18.0658L43.7654 44.5588C43.5065 45.8009 42.0473 46.3603 41.0244 45.6088L32.6575 39.4673L28.3927 43.8219C27.6433 44.586 26.3511 44.275 26.0296 43.2562L22.9526 33.4885L14.7046 31.0524C13.6212 30.7329 13.5586 29.2258 14.6086 28.8145L47.0658 16.1682ZM42.9971 22.0467C43.3582 21.7273 42.9386 21.1637 42.5295 21.4184L24.7268 32.4594C24.4137 32.6535 24.2697 33.0355 24.3803 33.3883L26.8081 44.0494C26.8562 44.2122 27.0899 44.1892 27.1108 44.0202L27.6536 35.8955C27.6744 35.6951 27.7704 35.5114 27.9208 35.3778L42.9971 22.0467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.5288 21.4183C42.938 21.1637 43.3576 21.7273 42.9965 22.0467L27.9203 35.3778C27.77 35.5114 27.674 35.6951 27.6531 35.8955L27.1103 44.0201C27.0895 44.1892 26.8556 44.2122 26.8076 44.0493L24.3798 33.3882C24.2691 33.0355 24.4132 32.6534 24.7263 32.4593L42.5288 21.4183Z",
    fill: "#9EC2E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.8959 44.1603C26.5034 44.0204 26.1715 43.7073 26.0296 43.2563L22.9526 33.4887L14.7046 31.0525C13.6212 30.733 13.5586 29.2259 14.6086 28.8147L47.0656 16.1685C47.863 15.8574 48.6793 16.1977 49.0822 16.8282C49.007 16.7134 48.9173 16.607 48.8171 16.513L26.7977 34.4888V35.2758L26.6766 35.1881L26.7977 40.144V44.1186C26.829 44.1333 26.8623 44.1458 26.8958 44.1562V44.1603H26.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.6584 39.4675L28.3936 43.8222C28.3582 43.8577 28.3206 43.8932 28.283 43.9245C28.2454 43.9559 28.2078 43.983 28.1682 44.0101C28.1661 44.0122 28.1661 44.0122 28.1661 44.0122C28.0868 44.0644 28.0054 44.1082 27.9198 44.1437C27.876 44.1604 27.8342 44.1771 27.7903 44.1875C27.6087 44.2418 27.4229 44.2564 27.2392 44.2377C27.1913 44.2335 27.1432 44.2252 27.0973 44.2168C27.091 44.2168 27.0849 44.2148 27.0786 44.2127C27.0327 44.2002 26.9866 44.1877 26.9408 44.173C26.9261 44.1689 26.9116 44.1646 26.8969 44.1563L26.7988 40.1441V35.2759L32.6584 39.4675Z",
    fill: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.2847 43.924C28.2465 43.9558 28.2082 43.9855 28.168 44.0131V44.011C28.2083 43.9834 28.2465 43.9558 28.2847 43.924Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.168 44.0098V44.0137C28.168 44.0137 28.168 44.0098 28.1641 44.0137C28.1641 44.0137 28.1641 44.0137 28.168 44.0098Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.918 44.1438C28.0039 44.1081 28.0855 44.0642 28.1651 44.0118C28.0855 44.064 28.0017 44.108 27.918 44.1438Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.2373 44.2374C27.421 44.2564 27.6068 44.2416 27.7884 44.1868C27.6569 44.229 27.5211 44.2479 27.3855 44.2479C27.3437 44.2479 27.302 44.2459 27.2624 44.2416C27.254 44.2417 27.2457 44.2417 27.2373 44.2374Z",
    fill: "#DADDE0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.2386 44.2375C27.247 44.2417 27.2554 44.2417 27.2638 44.2417C27.2197 44.2396 27.1797 44.2332 27.1377 44.2247C27.1712 44.2312 27.2049 44.2354 27.2386 44.2375Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.2396 44.2378C27.206 44.2357 27.1723 44.2314 27.1388 44.2251C27.124 44.223 27.1094 44.2209 27.0967 44.2166C27.1429 44.2251 27.1912 44.2336 27.2396 44.2378Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.9395 44.1727C26.9857 44.1876 27.032 44.2003 27.0783 44.2131C27.0594 44.2089 27.0405 44.2046 27.0215 44.2004C27.0131 44.1983 27.0047 44.1962 26.9984 44.1919C26.9793 44.1876 26.9584 44.1812 26.9395 44.1727Z",
    fill: "#DADDE0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M27.0205 44.2001C27.0399 44.2043 27.0593 44.2087 27.0787 44.213C27.0593 44.2108 27.0399 44.2066 27.0205 44.2001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M26.9398 44.1732C26.959 44.1818 26.9806 44.1882 26.9998 44.1925C26.9676 44.186 26.9355 44.1753 26.9033 44.1625C26.9161 44.1667 26.9268 44.1711 26.9398 44.1732Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M26.9412 44.1735C26.9282 44.1713 26.9172 44.1669 26.9042 44.1626C26.9021 44.1648 26.8977 44.1626 26.8955 44.1605V44.1562C26.9107 44.1648 26.9259 44.1691 26.9412 44.1735Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M26.7988 40.1439L26.8978 44.1561C26.8641 44.1456 26.8304 44.1331 26.7988 44.1185V40.1439Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M26.798 35.2757V40.1439L26.6758 35.188L26.798 35.2757Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M42.9965 22.047L27.9203 35.3781C27.77 35.5116 27.674 35.6953 27.6531 35.8958L27.1113 44.0211C27.0905 44.1902 26.8566 44.2132 26.8065 44.0503L24.3798 33.3886C24.2691 33.0359 24.4132 32.6538 24.7263 32.4597L42.529 21.4188C42.9381 21.164 43.3577 21.7277 42.9965 22.047Z",
    fill: "#ADBCC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_22020",
    x1: 31.4629,
    y1: 0,
    x2: 31.4629,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AA5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_22020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.0001,
    height: 62,
    fill: "white",
    transform: "translate(0.600586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.24d0556df831f25f602cb7c99db78c09.svg";
export { ForwardRef as ReactComponent };